<main class="home-page">
  <section class="hero" aria-label="Bienvenida">
    <div class="hero-content">
      <h1>
        <span>Bienvenido a</span>
        Ibro Food Safety
      </h1>
      <span class="hero-rule" aria-hidden="true"></span>
      <p>
        En esta app puedes realizar sus inscripciones.
        Para iniciar con su solicitud debe navegar a la opci&oacute;n
        <strong>Formulario</strong> ubicada en el men&uacute; superior.
      </p>
      <a routerLink="/form" class="form-link" aria-label="Ir al formulario">
        <mat-icon>description</mat-icon>
        <span>Ir al formulario</span>
        <mat-icon>chevron_right</mat-icon>
      </a>
    </div>

    <div class="hero-art" aria-hidden="true">
      <span class="hero-dot hero-dot-red"></span>
      <span class="hero-dot hero-dot-blue"></span>
      <span class="dot-grid"></span>
      <span class="shield">
        <mat-icon>check</mat-icon>
      </span>
      <span class="wave"></span>
    </div>
  </section>

  <section class="featured" aria-label="Destacados">
    <header class="featured-title">
      <mat-icon aria-hidden="true">star_outline</mat-icon>
      <h2>Destacados</h2>
    </header>

    <div class="carousel-shell">
      <button mat-icon-button class="carousel-button carousel-prev" type="button" aria-label="Imagen anterior" (click)="prevImage()">
        <mat-icon>chevron_left</mat-icon>
      </button>

      <figure class="carousel-card">
        <img [src]="images[currentIndex]" alt="Frase destacada de IBRO Food Safety">
      </figure>

      <button mat-icon-button class="carousel-button carousel-next" type="button" aria-label="Imagen siguiente" (click)="nextImage()">
        <mat-icon>chevron_right</mat-icon>
      </button>
    </div>

    <div class="carousel-dots" aria-label="Selector de destacados">
      @for (image of images; track image; let i = $index) {
        <button
          type="button"
          [class.active]="i === currentIndex"
          [attr.aria-label]="'Mostrar destacado ' + (i + 1)"
          [attr.aria-current]="i === currentIndex ? 'true' : null"
          (click)="goToImage(i)">
        </button>
      }
    </div>
  </section>
</main>
